import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {  Observable } from 'rxjs';
import { LogDTO } from '../models/log';


@Injectable({
  providedIn: 'root'
})

export class TrackingService {

  private pathAPI = environment.urlAPI;
  private controller = "Tracking/";

  constructor(private http: HttpClient) { }


  public trackUser(data: LogDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "TrackUser", data);
  }

  public trackElement(id: string, type: number): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackElement/' + id + '/' + type, null);
  }

  public trackAccessCampaign(idCampaign: string): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackAccessCampaign/' + idCampaign, null);
  }

  public trackCampaignPub(id: string, idLogType): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'TrackCampaignPub/' + id + "/" + idLogType);
  }


 
}